const {
    trim, find, toLower, map,
} = require('lodash');

class ReviewListController {
    constructor(settings) {
        this.settings = settings;
    }

    $onInit() {
        this.reviewSource = map(this.settings.ratingreview.reviewSource, source => ({
            key: trim(toLower(source[0])),
            value: source[1],
        }));
        this.pageSize = this.settings.ratingreview && this.settings.ratingreview.pageSize ? this.settings.ratingreview.pageSize : null;
    }

    $onChanges(changes) {
        if ((changes.sortBy || changes.sortOptions) && this.sortOptions != null) {
            this.sortType = this.getSortType();
        }
        if (changes.totalRecordCount && this.pageSize) {
            this.numberOfPages = Math.ceil(this.totalRecordCount / this.pageSize) || 1;
        }
    }

    getSortType() {
        return find(this.sortOptions.sortTypes, { Value: this.sortBy }) || this.sortOptions.sortTypes[0];
    }

    onSortByChangedEvent(option) {
        this.sortBy = option.Value;
        this.pageNumber = 1;
        this.onSortByChanged({ value: option.Value, text: option.Text }).then((items) => {
            this.items = items;
        });
    }

    onPageSelectedEvent(pageNumber) {
        this.pageNumber = pageNumber;
        this.onPageSelected({ value: pageNumber }).then((items) => {
            this.items = items;
        });
    }
}

ReviewListController.$inject = ['Settings'];

const reviewListComponentDefinition = {
    controller: ReviewListController,
    template: require('./review-list.component.html').trim(),
    bindings: {
        pageNumber: '<',
        sortBy: '<',
        sortOptions: '<',
        items: '<',
        totalRecordCount: '<',
        error: '<?',
        isLoading: '<?',
        onSortByChanged: '&',
        onPageSelected: '&',
        setSpinnerFocused: '&',
    },
};

module.exports = {
    ReviewListController,
    reviewListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/review/review-list.component.js